import { BookSection } from '@Models';
import {
  buildBookSectionState,
  BookSectionState,
  BookActionState,
} from '@Stores/index';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: BookSectionState = buildBookSectionState({
  entity: null,
}) satisfies BookSectionState as BookSectionState;

const myBookSectionSlice = createSlice({
  name: 'book-section',
  initialState,
  reducers: {
    setError(state: BookSectionState, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
      state.hasError = true;
    },
    setLoading(state: BookSectionState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setBookSection(
      state: BookSectionState,
      action: PayloadAction<BookSection>,
    ) {
      state.entity = action.payload;
      state.id = action.payload.id;
      state.isLoading = false;
      state.hasError = false;
      state.errorMessage = null;
    },
    setCancel(state: BookSectionState) {
      state.action = null;
    },
    setRequestClone(
      state: BookSectionState,
      action: PayloadAction<BookSection>,
    ) {
      state.action = BookActionState.Clone;
      state.entity = action.payload;
      state.id = action.payload.id;
    },
    setRequestEdit(
      state: BookSectionState,
      action: PayloadAction<BookSection>,
    ) {
      state.action = BookActionState.Edit;
      state.entity = action.payload;
      state.id = action.payload.id;
    },
    setRequestDelete(
      state: BookSectionState,
      action: PayloadAction<BookSection>,
    ) {
      state.action = BookActionState.Delete;
      state.entity = action.payload;
      state.id = action.payload.id;
    },
  },
});

export default myBookSectionSlice;
